import { EinzaApiService } from "@/services/einzaApi"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryMixColors = {
  async mixColors(_parent, args, context, _info) {
    const { productId, collectionId } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.MIXED_PRODUCTS,
      operation: Operations.READ,
    })

    const method = `farben/list/${productId}/${collectionId}`
    const einzaResponse = (await EinzaApiService.getData(method))?.data

    if (!einzaResponse?.length) {
      return { total: 0, items: [] }
    }

    return {
      total: einzaResponse.length,
      items: einzaResponse.map((mixColor) => ({
        color: mixColor.farbton,
        colorCode1: mixColor.farbtonBez1,
        colorCode2: mixColor.farbtonBez2,
        colorCode3: mixColor.farbtonBez3,
        colorCode4: mixColor.farbtonBez4,
        hbw: mixColor.hbw,
        rcolor: mixColor.rcolor,
        gcolor: mixColor.gcolor,
        bcolor: mixColor.bcolor,
        sysId: mixColor.sysId,
      })),
    }
  },
}
